import React from "react";
import "./ButtonMflClub.css";

interface ButtonMflClubProps {
  clubId?: int;
}

const ButtonMflClub: React.FC<ButtonMflClubProps> = ({ clubId }) => {
  return (
    <button
      className="btn btn-sm background-mfl text-black w-100"
      onClick={() => window.open("https://app.playmfl.com/clubs/" + clubId, "_blank")}
    >
      MFL<i className="bi bi-caret-right-fill"></i>
    </button>
  );
};

export default ButtonMflClub;
